import React, { useEffect, useRef } from 'react';
import styles from './ConfirmModal.module.css';

// SCRUM-430: the dialog owns the keyboard while open — Enter or Space
// confirms, Escape cancels — so an ops review (d, Enter, d, Enter …) never
// needs the mouse. Confirm is focused on open for the same reason.
export default function ConfirmModal({ message, onConfirm, onCancel }) {
  const confirmRef = useRef(null);
  const cancelRef = useRef(null);
  useEffect(() => {
    confirmRef.current?.focus();
    const onKey = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        if (document.activeElement === cancelRef.current) return; // tabbed to Cancel: the button handles it
        e.preventDefault(); e.stopPropagation(); onConfirm();
      }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); onCancel(); }
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [onConfirm, onCancel]);
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <p className={styles.message}>{message}</p>
        <div className={styles.actions}>
          <button ref={cancelRef} className={styles.cancel} onClick={onCancel}>Cancel</button>
          <button ref={confirmRef} className={styles.confirm} onClick={onConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
}
